import React, {memo, useMemo} from 'react'
import {Space} from 'antd'
import {VStack} from '../../../../../../ui/Stack'
import dayjs from 'dayjs'
import {StagePlanItemOrderI} from "../../../model/types/types";

export const StagePlanItemOrder: React.FC<StagePlanItemOrderI> = memo((props: StagePlanItemOrderI) => {
  const {
    name,
    date_plan,
    time_plan,
    date_adjusted,
    date_fact,
    rating,
    responsible,
    organization,
  } = props

  const dateTemplate = 'DD.MM.YYYY HH:mm';

  const datePlanFormat = useMemo<null | string>(() => {
    if (date_plan) {
      const formattedDate = dayjs(date_plan).format('DD.MM.YYYY');
      if (time_plan) {
        return `${formattedDate} ${time_plan}`;
      } else {
        return dayjs(date_plan).format(dateTemplate);
      }
    }
    return null;
  }, [date_plan, time_plan]);

  const dateFact = useMemo<null | string>(
    () => date_fact ? dayjs(date_fact).format(dateTemplate) : null,
    [date_fact],
  )

  return (
    <VStack align={'start'} style={{paddingBottom: '16px'}}>
      <Space size={4}>
        <span style={{ fontWeight: 'bold'}}>{name}</span>
      </Space>
      {datePlanFormat && <Space size={4}>
        <span>Дата (план):</span> {datePlanFormat}
      </Space>}
      {date_adjusted && <Space size={4}>
        <span>Дата (скорректированная):</span> {date_adjusted}
      </Space>}
      {dateFact && <Space size={4}>
        <span>Дата (факт):</span> {dateFact}
      </Space>}
      {responsible && <Space size={4}>
        Ответственный:
        <span style={{ color: '#a8adb4'}}>{responsible}</span> {organization}
      </Space>}
      {Boolean(rating) && <Space size={4}>
        Рейтинг:
        <span style={{ color: '#a8adb4'}}>{`${Number(rating).toFixed(2)}%`}</span>
      </Space>}
    </VStack>
  )
})
